import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import { BlockType, CodeBlock } from '@appblocks/codegeneration/types';

export default class Sock extends BaseFeature {
    constructor() {
        super();
        this.id = 'sock';
        this.fileLinks = [
            // 'sock\\sock.tbs',
            // 'sock\\sock.tbh',
        ];
        this.files = [
            'libraries/sock/sock.tbh',
            'libraries/sock/sock.tbs',
        ];
    }

    getFiles(): Array<string> {
        if (this.project.runtime !== 'tios') {
            return [];
        }
        return this.files;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'zephyr') {
            blocks.push({
                location: 'PRJ_CONF',
                id: 'CONFIG_NET_SOCKETS_POSIX_NAMES=y',
                blockType: BlockType.CODE,
                template: `
CONFIG_NET_SOCKETS_POSIX_NAMES=y`,
            });
            blocks.push({
                location: 'PRJ_CONF',
                blockType: BlockType.CODE,
                template: `
#CONFIG_NET_SOCKETS_LOG_LEVEL_DBG=y`,
            });
        }

        return blocks;
    }
}
